import { createSelector } from 'reselect';

const selectAProject = (state, props) => {
    return state.projects.find(project =>
        `${project.projectId}` === props.match.params.projectId);
};

export const makeSelectAProject = createSelector(
    selectAProject,
    project => project,
);



// WEBPACK FOOTER //
// ./src/containers/common/projects/selectors.js